import { ReactElement, memo } from "react";

import { ICatalogueCustomization } from "../../../../apis/useGetCatalogueData/types";
import { Nullable } from "../../../../common/types/types";
import Condition from "../../../../components/Conditional/Condition";
import { ICustomizationSetItem } from "../setitems/types";
import PDPCustomization from "./PDPCustomization";

interface IProps {
	customizations?: Nullable<ICatalogueCustomization[]>;
	setitem?: Nullable<ICustomizationSetItem>;
	selectedCustomizations?: Nullable<ICatalogueCustomization>[];
}

const PDPCustomizations = ({
	customizations,
	setitem,
	selectedCustomizations = [],
}: IProps): ReactElement => {
	return (
		<Condition check={!!customizations?.length}>
			<div className={`PDPCustomizationsContainer${setitem ? " SetItemCustomization" : ""}`}>
				{customizations?.map((custom, idx) => (
					<PDPCustomization
						idx={idx}
						customization={custom}
						key={custom.id}
						setitem={setitem}
						selectedCustomization={selectedCustomizations[idx]}
					/>
				))}
			</div>
		</Condition>
	);
};

export default memo(PDPCustomizations);
